// Règles « réservé au Master Set + » du compte. Le serveur les applique aux cartes
// qu'il sert (card.master_plus_only) et à la complétion : après un changement, les
// vues rechargent leurs cartes, et onChanged rafraîchit les pourcentages.
import { useState, useCallback, useEffect } from "react";
import { fetchMasterSetRules, addMasterSetRule, removeMasterSetRule } from "../lib/api";

export function useMasterSetRules(onChanged) {
  const [rules, setRules] = useState([]);

  useEffect(() => {
    fetchMasterSetRules().then(setRules).catch(err => console.error(err));
  }, []);

  const addRule = useCallback(async (rule) => {
    const created = await addMasterSetRule(rule);
    setRules(prev => [...prev.filter(r => r.id !== created.id), created]);
    onChanged?.();
  }, [onChanged]);

  const removeRule = useCallback(async (ruleId) => {
    await removeMasterSetRule(ruleId);
    setRules(prev => prev.filter(r => r.id !== ruleId));
    onChanged?.();
  }, [onChanged]);

  return { rules, addRule, removeRule };
}
